import * as tslib_1 from "tslib";
import { ItemContainer } from './item_container';
var Tab = /** @class */ (function (_super) {
    tslib_1.__extends(Tab, _super);
    function Tab(param) {
        return _super.call(this, param) || this;
    }
    Tab.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Tab" });
    };
    Tab.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Tab;
}(ItemContainer));
export { Tab };
//# sourceMappingURL=tab.js.map